module.exports = __webpack_public_path__ + "d6c9efc5e32331bf0063cd00c8cc394b.MP3";